"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParametersAndModesRowKindSchema = exports.ParametersAndModesRowKind = exports.PARAMETERS_AND_MODES_TABLE_DIRECTIVE = void 0;
const zod_1 = require("zod");
exports.PARAMETERS_AND_MODES_TABLE_DIRECTIVE = 'parameters-and-modes-table';
var ParametersAndModesRowKind;
(function (ParametersAndModesRowKind) {
    ParametersAndModesRowKind["Parameter"] = "parameter";
    ParametersAndModesRowKind["Mode"] = "mode";
})(ParametersAndModesRowKind || (exports.ParametersAndModesRowKind = ParametersAndModesRowKind = {}));
exports.ParametersAndModesRowKindSchema = zod_1.z.nativeEnum(ParametersAndModesRowKind);
//# sourceMappingURL=ParametersAndModesTable.js.map